import { Box, Divider, styled } from '@mui/material';

type Props = {
  color: string;
};
export const GradientBar = ({ color }: Props) => {
  return (
    <StyledBox color={color}>
      <VerticalDivider />
      <VerticalDivider />
      <VerticalDivider />
      <VerticalDivider />
      <VerticalDivider />
    </StyledBox>
  );
};

const VerticalDivider = () => {
  return <Divider orientation='vertical' flexItem />;
};

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<Props>(({ color }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  flexGrow: 1,
  height: '8px',
  borderRadius: 4,
  background: `linear-gradient(to right, #FFFFFF, ${color})`,
}));
